import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import { usePreviousDistinct } from 'react-use';
import { useAppSelector } from 'utils/redux/useAppSelector';
/**
 * A hook that updates the local list in the useAgent hook, whenever an
 * agent/user is updated from the UserModal.
 *
 * @param updateAgent The updateAgent function from the useAgents hook
 */
export const useUpdateAgent = (updateAgent) => {
    const { user, asyncStatus } = useAppSelector((state) => ({
        user: state.userModal.user,
        asyncStatus: state.userModal.meta.asyncStatus,
    }), shallowEqual);
    const previousAsyncStatus = usePreviousDistinct(asyncStatus);
    useEffect(() => {
        if (previousAsyncStatus === 'loading' &&
            asyncStatus === 'succeeded' &&
            user &&
            'id' in user) {
            updateAgent(user, (firstAgent, secondAgent) => firstAgent.id === secondAgent.id);
        }
    }, [previousAsyncStatus, user, asyncStatus, updateAgent]);
};
